import { useRef, useState } from "react";
import { api } from "@/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Upload } from "lucide-react";
import { toast } from "sonner";

export default function ImportDialog({ open, onClose }) {
  const fileRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const doImport = async () => {
    const file = fileRef.current?.files?.[0];
    if (!file) { toast.error("Seleziona un file .xlsm"); return; }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await api.post("/import", fd);
      toast.success(`Import completato: ${res.data.personnel} personale, ${res.data.sites} cantieri, ${res.data.subcontractors} subappaltatori`);
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore durante l'import");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-white rounded-sm" data-testid="import-dialog" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="text-lg font-bold tracking-tight">Import da XLSM</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-slate-500">
          Il file deve contenere i fogli: personale disponibile, lista cantieri, aziende subappaltatrici.
          L'import sostituisce le anagrafiche attuali.
        </p>
        <input data-testid="import-file-input" ref={fileRef} type="file" accept=".xlsm,.xlsx"
          className="text-sm border border-slate-300 rounded-sm p-2 w-full" />
        <Button data-testid="import-submit-button" onClick={doImport} disabled={loading}
          className="rounded-sm bg-slate-900 hover:bg-slate-700 text-white">
          <Upload className="w-4 h-4 mr-1" /> {loading ? "Importazione..." : "Importa"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
